import request from '@/utils/request'


export function userSex(query) {
  return request({
    url: '/biz/admin/statistics/user/sex',
    method: 'get',
    params: query
  })
}

export function userLevel(query) {
  return request({
    url: '/biz/admin/statistics/user/level',
    method: 'get',
    params: query
  })
}

export function userLevelLine(query) {
  return request({
    url: '/biz/admin/statistics/user/level/line',
    method: 'get',
    params: query
  })
}
export function userRegisterType(query) {
  return request({
    url: '/biz/admin/statistics/user/register-type',
    method: 'get',
    params: query
  })
}


export function userAddressMap(query) {
  return request({
    url: '/biz/admin/statistics/user/address/map',
    method: 'get',
    params: query
  })
}

export function userBalanceCount(query) {
  return request({
    url: '/biz/admin/statistics/user/balance/count',
    method: 'get',
    params: query
  })
}

export function userPayAmountCount(query) {
  return request({
    url: '/biz/admin/statistics/user/payAmount/count',
    method: 'get',
    params: query
  })
}





export function userSource(query) {
  return request({
    url: '/biz/admin/statistics/user/source',
    method: 'get',
    params: query
  })
}

export function userAge(query) {
  return request({
    url: '/biz/admin/statistics/user/age',
    method: 'get',
    params: query
  })
}

export function userAxis(query) {
  return request({
    url: '/biz/admin/statistics/user/axis',
    method: 'get',
    params: query
  })
}


export function userSexOrder(query) {
  return request({
    url: '/biz/admin/statistics/user/sex/order',
    method: 'get',
    params: query
  })
}

export function userAddressOrder(query) {
  return request({
    url: '/biz/admin/statistics/user/address/order',
    method: 'get',
    params: query
  })
}


export function userAgeOrder(query) {
  return request({
    url: '/biz/admin/statistics/user/age/order',
    method: 'get',
    params: query
  })
}

export function userActive(query) {
  return request({
    url: '/biz/admin/statistics/user/active',
    method: 'get',
    params: query
  })
}

export function userInvite(query) {
  return request({
    url: '/biz/admin/statistics/user/invite',
    method: 'get',
    params: query
  })
}

export function userSta(query) {
  return request({
    url: '/biz/admin/statistics/user/user/page',
    method: 'get',
    params: query
  })
}


/*搜索柱状图*/
export function userSearchAxis(query) {
  return request({
    url: '/biz/admin/statistics/user/search/axis',
    method: 'get',
    params: query
  })
}


export function userSearchWord(query) {
  return request({
    url: '/biz/admin/statistics/user/search/word',
    method: 'get',
    params: query
  })
}

export function userSearchRank(query) {
  return request({
    url: '/biz/admin/statistics/user/search/rank',
    method: 'get',
    params: query
  })
}

export function userSearchType(query) {
  return request({
    url: '/biz/admin/statistics/user/search/type',
    method: 'get',
    params: query
  })
}
/*近一月联盟邀请用户*/
export function distributorUserInviteList(query) {
  return request({
    url: '/biz/admin/statistics/user/distributor/invite',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}


export function distributorUserAmountChart(query) {
  return request({
    url: '/biz/admin/statistics/user/distributor/amount',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

/*增长*/
export function distributorUserGrowth(query) {
  return request({
    url: '/biz/admin/statistics/user/distributor/growth',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
/*累计*/
export function distributorUserCumulative(query) {
  return request({
    url: '/biz/admin/statistics/user/distributor/cumulative',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}